import React from 'react';
import ServiceLayout from '../layouts/ServiceLayout';
import { Box, Typography, Grid, Paper } from '@mui/material';

const VestibularRehabilitation = () => {
  const serviceData = {
    title: "Vestibular Rehabilitation",
    image: "/Vestibular rehabilitation.png",
    description: "Our vestibular rehabilitation program is designed to help patients suffering from balance disorders, dizziness, and vertigo. Using specialized techniques and exercises, we help restore balance and reduce symptoms.",
    benefits: [
      "Reduced dizziness and vertigo",
      "Improved balance and stability",
      "Better spatial orientation",
      "Increased confidence in movement",
      "Enhanced daily function",
      "Prevention of falls"
    ],
    approach: [
      "Comprehensive vestibular assessment",
      "Customized exercise programs",
      "Balance retraining",
      "Gaze stabilization exercises",
      "Habituation techniques",
      "Home exercise instruction"
    ],
    additionalContent: (
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Treatment Programs
        </Typography>
        <Grid container spacing={3}>
          {[
            {
              title: "BPPV Treatment",
              description: "Specialized maneuvers and exercises for treating Benign Paroxysmal Positional Vertigo."
            },
            {
              title: "Balance Training",
              description: "Progressive exercises to improve balance and reduce fall risk."
            },
            {
              title: "Gaze Stabilization",
              description: "Exercises to improve visual focus and reduce dizziness during head movements."
            }
          ].map((program, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 24px rgba(0,150,136,0.15)'
                  }
                }}
              >
                <Typography variant="h6" gutterBottom color="primary">
                  {program.title}
                </Typography>
                <Typography variant="body2">
                  {program.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    )
  };

  return <ServiceLayout {...serviceData} />;
};

export default VestibularRehabilitation; 